module.exports = __webpack_public_path__ + "img/merchant_register_code_bg@2x.5f810d20.png";